
/* ----- Apps Routes ----- */
import adminRoutes from "@/router/apps/admin-routes";
import clientsAreaRoutes from "@/router/apps/clients-area-routes";
import pwaRoutes from "@/router/apps/pwa-routes";

/* ----- Views ----- */
import NotFound from "@/pages/Dashboard/Pages/NotFound";

/* ----- ----- ----- ----- ----- ----- ----- */

const routes = [
    ...adminRoutes,
    ...clientsAreaRoutes,
    ...pwaRoutes,
    {
        path: '*',
        name: 'catchAll',
        component: NotFound
    }
];
export default routes;
